<template>
  <a-modal class="date-modal-css" v-model="fillModal" title="一键填充" width="450px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="是否主动变更"
        prop="activePassive"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
      >
        <a-select v-model="formData.activePassive" allowClear>
          <a-select-option v-for="item in loopUpData.updateMethodList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="变更类型"
        prop="changeType"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
      >
        <a-select v-model="formData.changeType" allowClear>
          <a-select-option v-for="item in loopUpData.updateTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <a-form-model-item
      label="交期变更套数"
      prop="assessmentChangeQuantity"
      :labelCol="{ style: 'width: 120px;float:left' }"
      :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
    >
      <a-input-number
        style="width: 100%"
        v-model="formData.assessmentChangeQuantity"
        :min="0"
        :parser="(value) => `${value}`.replace(/\D/g, '')"
        :formatter="(value) => `${value}`.replace(/\D/g, '')"
      />
    </a-form-model-item>
    <a-form-model-item
      prop="newAssessmentDeliveryDate"
      :labelCol="{ style: 'width: 120px;float:left' }"
      :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
    >
      <span slot="label">
        新考核交期&nbsp;
        <a-tooltip title="提示：零部件支持年月日-时分秒，组装仅支持年月日（填充时将默认为年月日）">
          <a-icon type="question-circle-o" />
        </a-tooltip>
      </span>
      <a-date-picker
        style="width: 100%"
        v-model="formData.newAssessmentDeliveryDate"
        format="YYYY-MM-DD HH:mm:ss"
        valueFormat="YYYY-MM-DD HH:mm:ss"
        :show-time="{ defaultValue: moment('12:00:00', 'HH:mm:ss') }"
      />
    </a-form-model-item>
    <a-form-model-item
      label="变更责任方"
      prop="responsibleParty"
      :labelCol="{ style: 'width: 120px;float:left' }"
      :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
    >
      <a-select
        style="width: 100%"
        show-search
        option-filter-prop="children"
        v-model="formData.responsibleParty"
        mode="multiple"
        :maxTagCount="2"
        allowClear>
        <a-select-option v-for="item in loopUpData.changeLiabilityList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item
      label="变更原因"
      prop="changeReason"
      :labelCol="{ style: 'width: 120px;float:left' }"
      :wrapperCol="{ style:'width:calc(100% - 120px) !important;float:left'}"
    >
      <a-input type="textarea" :autoSize="{minRows:2}" v-model="formData.changeReason" :maxLength="200" />
    </a-form-model-item>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">确认填充</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
export default {
  name: 'FillModal',
  data () {
    return {
      loading: false,
      fillModal: false,
      formData: {
        activePassive: undefined, // 是否主动变更
        changeType: undefined, // 变更类型
        newAssessmentDeliveryDate: undefined, // 新考核交期
        assessmentChangeQuantity: undefined, // 交期变更套数
        responsibleParty: undefined, // 变更责任方
        changeReason: undefined // 变更原因
      }
    }
  },
  props: {
    loopUpData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    moment,
    show() {
      this.reset()
      this.fillModal = true
    },
    onCancel() {
      this.fillModal = false
    },
    reset() {
      this.formData = {
        activePassive: undefined, // 是否主动变更
        changeType: undefined, // 变更类型
        newAssessmentDeliveryDate: undefined, // 新考核交期
        assessmentChangeQuantity: undefined, // 交期变更套数
        responsibleParty: undefined, // 变更责任方
        changeReason: undefined // 变更原因
      }
    },
    // 提交
    onSubmit() {
      const getFill = Object.keys(this.formData).find(item => this.formData[item])
      if(!getFill) {
        this.$message.warning('请填写需要一键填充的字段')
        return
      }
      this.$emit('fillData', this.formData)
      this.fillModal = false
    }
  }
}
</script>

<style scoped>

</style>
